export const MIN_STRING_LENGTH = 1;
export const MAX_FULL_NAME = 100